import React, { useEffect, useState } from 'react';
import { Input, Form, Button, Row, Col, Radio } from 'antd';
import { retrieveTokenCount } from '../../utils/api.js';
import PropTypes from 'prop-types';

const { TextArea } = Input;
const { Item } = Form;

const TOKEN_TIMEOUT_DELAY = 400;

function TokenTextArea({
	autosize,
	inputs,
	model,
	responseLength,
	instruction,
	onChange,
	onError,
	...props
}) {
	const [text, setText] = useState('');
	const [tokenTimeout, setTokenTimeout] = useState(null);
	const [tokenCount, setTokenCount] = useState(0);

	const updateTokenCount = async (textData) => {
		if (!textData || !model || !model.id) {
			setTokenCount(0);
			return;
		}

		try {
			const response = await retrieveTokenCount(textData, model.id, instruction);

			if (response.tokenCount) {
				setTokenCount(response.tokenCount);
			}
		} catch (error) {
			setTokenCount('-');
			console.error(error);
			if (onError) {
				onError(error);
			}
		}
	};

	const getTokenCountColor = () => {
		if (tokenCount && tokenCount > model.tokenLimit - responseLength) {
			return 'red';
		}

		return 'black';
	};

	const handleTextChange = async (textData) => {
		// Set the text state
		setText(textData);
		onChange(textData);

		// Clear the token interval and timeout
		clearTimeout(tokenTimeout);

		setTokenTimeout(
			setTimeout(async () => {
				await updateTokenCount(textData);
				//clearInterval(tokenInterval);
			}, TOKEN_TIMEOUT_DELAY)
		);
	};

	useEffect(() => {
		updateTokenCount(text);

		return () => {
			if (tokenTimeout) {
				clearTimeout(tokenTimeout);
			}
		};
	}, [model, instruction]);

	return (
		<div>
			<Item>
				<Row>
					<Col span={24}>{props.label && <label>{props.label}</label>}</Col>
				</Row>
				<Row align='middle' type='flex' justify='justify-content'>
					<Col span={20}>
						<Radio.Group
							onChange={(e) => {
								let val = e.target.value;
								if (val === 'custom') {
									handleTextChange('');
								} else {
									handleTextChange(inputs[val].value);
								}
							}}
							defaultValue={'custom'}
						>
							<Radio value='custom'>Fritext</Radio>
							{inputs.map((input, index) => {
								if (input.value === '') {
									return null;
								}

								return (
									<Radio key={index} value={index}>
										{input.key}
									</Radio>
								);
							})}
						</Radio.Group>
					</Col>
					<Col style={{ marginLeft: 'auto' }}>
						<Button size={'small'} type='danger' onClick={() => handleTextChange('')}>
							Rensa
						</Button>
					</Col>
				</Row>
				<TextArea
					value={text}
					autosize={autosize}
					onChange={(e) => handleTextChange(e.target.value)}
					style={{ minHeight: '150px' }}
				/>
				<div style={{ textAlign: 'right' }}>
					<span style={{ color: getTokenCountColor() }}>{tokenCount}</span> /{' '}
					{model ? model.tokenLimit - responseLength : '?'} tokens
				</div>
			</Item>
		</div>
	);
}

TokenTextArea.defaultProps = {
	inputs: [],
	instruction: '',
	onChange: () => {},
	onError: () => {},
	responseLength: 250,
};

TokenTextArea.propTypes = {
	inputs: PropTypes.array,
	instruction: PropTypes.string.isRequired,
	model: PropTypes.object,
	onChange: PropTypes.func,
	onError: PropTypes.func,
	responseLength: PropTypes.number,
};

export default TokenTextArea;



// WEBPACK FOOTER //
// ./src/components/ai/TokenTextArea.jsx